import App from './src/app';
import { renderApp } from '@flexn/create';

const Main = renderApp(App);
export default Main;
